import React, { useState } from "react";
import IConButtonApp from "../../IconButtonApp/IConButtonApp";
import AvatarApp from "../../avatarapp/AvatarApp";
import { LuLogOut, LuSettings } from "react-icons/lu";
import { useDispatch, useSelector } from "react-redux";
import { Button, Divider, Menu, Stack, Typography } from "@mui/material";
import { logoutUser } from "../../../../redux/reducers/auth.reducer";
import { persistor } from "../../../../redux/reducers/root";
import { useAlertContext } from "../../../../contexts/alert/AlertProvider";

function UserSetting() {
  const { showAlert } = useAlertContext();
  const profile = useSelector((state: any) => state.auth.profile);
  const [anchorMenu, setAnchorMenu] = useState<HTMLElement>();
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(logoutUser());
    localStorage.clear();
    persistor.pause();
    persistor.flush().then(() => {
      window.location.reload();
      return persistor.purge();
    });
  };

  const handleCloseMenu = () => {
    setAnchorMenu(undefined);
  };

  return (
    <>
      <Menu
        anchorEl={anchorMenu}
        open={!!anchorMenu}
        onClose={handleCloseMenu}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        PaperProps={{ elevation: 1 }}
      >
        <Stack sx={{ minWidth: "300px" }}>
          <Stack sx={{ px: 2, py: 1 }}>
            <Typography sx={{ fontSize: "20px", fontWeight: 600 }}>
              Xin chào{" "}
              <Typography component="span" sx={{ fontSize: "16px" }}>
                {profile?.name}
              </Typography>
            </Typography>
            <Typography>Tài khoản: {profile?.email}</Typography>
          </Stack>
          <Divider />
          <Stack sx={{ px: 2, py: 1 }}>
            <Button
              color="error"
              startIcon={<LuLogOut size={14} />}
              sx={{ textTransform: "none", fontWeight: 400 }}
              onClick={() =>
                showAlert({
                  title: "Đăng xuất",
                  type: "info",
                  message: "Bạn sẽ đăng xuất khỏi hệ thống",
                  onConfirm: handleLogout,
                })
              }
            >
              Đăng xuất
            </Button>
          </Stack>
        </Stack>
      </Menu>
      <IConButtonApp
        sx={{ gap: 1, borderRadius: "50px" }}
        onClick={(e) => setAnchorMenu(e.currentTarget)}
      >
        <AvatarApp
          name={profile?.name}
          sx={{ width: "34px", height: "34px", fontSize: "14px" }}
        />
        <LuSettings size={24} />
      </IConButtonApp>
    </>
  );
}

export default UserSetting;
